import { render } from "./Menu.vue?vue&type=template&id=ed839d9e"
import script from "./Menu.vue?vue&type=script&lang=ts"
export * from "./Menu.vue?vue&type=script&lang=ts"

import "./Menu.vue?vue&type=style&index=0&id=ed839d9e&lang=scss"
script.render = render

export default script